"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenAccessOptions = void 0;
exports.ScreenAccessOptions = ["yes", "no", "unknown"];
//# sourceMappingURL=brandPartnerships.js.map